import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface MobileCardHeaderProps {
  action?: ReactNode
  className?: string
  icon?: ReactNode
  subtitle?: ReactNode
  title: ReactNode
}

function MobileCardHeader({ action, className, icon, subtitle, title }: MobileCardHeaderProps) {
  return (
    <div className={twMerge('flex items-center gap-2', className)}>
      {icon}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="text-text-primary truncate text-base">{title}</div>
        {subtitle ? <div className="text-text-tertiary truncate text-sm">{subtitle}</div> : null}
      </div>
      {action}
    </div>
  )
}

export { MobileCardHeader }
export type { MobileCardHeaderProps }
